// Currently status bar — edit these whenever things change.
// Instagram followers: update manually or wire up a Netlify function to automate.

const LISTENING_OPTIONS = [
  "Yngwie Malmsteen — Rising Force",
  "Joe Satriani — Surfing with the Alien",
  "Gary Moore — Still Got the Blues",
  "Stevie Ray Vaughan — Texas Flood",
  "B.B. King — Live at the Regal",
  "Carlos Santana — Abraxas",
  "Jimi Hendrix — Electric Ladyland",
  "Rory Gallagher — Irish Tour",
  "Peter Green — Then Play On",
  "Eric Clapton — Layla",
];

const randomAlbum =
  LISTENING_OPTIONS[Math.floor(Math.random() * LISTENING_OPTIONS.length)];

export const STATUS = {
  prefix: "Currently",
  items: [
    { label: "Building SaaS agents" },
    { label: "♪ Listening to", value: randomAlbum },
    { label: "Reading", value: "The Art of War" },
    {
      label: "Trying to make Eva Luna famous",
      href: "https://www.instagram.com/the.evaluna.cat/",
    },
  ],
};

// Eva Luna Instagram
export const EVA_LUNA = {
  instagram: "https://www.instagram.com/the.evaluna.cat/",
  handle: "@the.evaluna.cat",
};
